(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/pool-betting/best-bet-rows/assets/javascripts/buttons/mask-toggle-button.js') >= 0) return;  svs.modules.push('/components/pool-betting/best-bet-rows/assets/javascripts/buttons/mask-toggle-button.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

const _ReactRouterDOM = ReactRouterDOM,
  useHistory = _ReactRouterDOM.useHistory;
const Button = svs.ui.ReactButton;
const clx = svs.components.lbUtils.clx;
const PARAM_IGNORE_MODIFIED_RESULT = svs.components.sport.tipsenShared.PARAM_IGNORE_MODIFIED_RESULT;
const useBestBetRows = svs.components.poolBetting.bestBetRows.hooks.useBestBetRows;

const removeSearchParamIgnoringModifiedResult = history => {
  if (history && typeof history.replace === 'function') {
    const params = new URLSearchParams(history.location.search || '');
    params.delete(PARAM_IGNORE_MODIFIED_RESULT);
    const search = params.toString();

    history.replace(_objectSpread(_objectSpread({}, history.location), {}, {
      search: search ? "?".concat(search) : ''
    }));
    return;
  }

  const url = new URL(window.location.href);
  url.searchParams.delete(PARAM_IGNORE_MODIFIED_RESULT);
  const search = url.searchParams.toString();
  const targetUrl = "".concat(url.pathname).concat(search ? "?".concat(search) : '').concat(url.hash);
  window.history.replaceState({}, '', targetUrl);
};
const MaskToggleButton = _ref => {
  let className = _ref.className,
    enableReMasking = _ref.enableReMasking,
    isDrawFinalized = _ref.isDrawFinalized;
  const history = useHistory();
  const _useBestBetRows = useBestBetRows(),
    clearMaskedOutcomes = _useBestBetRows.clearMaskedOutcomes,
    maskAllOutcomes = _useBestBetRows.maskAllOutcomes,
    hasMaskedOutcomes = _useBestBetRows.hasMaskedOutcomes;
  const maskText = isDrawFinalized ? 'Rätta om spelet' : 'Dölj resultat';
  const unmaskText = isDrawFinalized ? 'Rätta spelet' : 'Visa alla resultat';
  if (!hasMaskedOutcomes && !enableReMasking) {
    return null;
  }
  return React.createElement(Button, {
    block: true,
    className: clx('pb_best_bet_rows__buttons__mask_toggle_button', className, {
      'pb_best_bet_rows__buttons__mask_toggle_button--unmasked': !hasMaskedOutcomes
    }),
    inverted: true,
    onClick: () => {
      if (hasMaskedOutcomes) {
        clearMaskedOutcomes();
      } else {
        removeSearchParamIgnoringModifiedResult(history);
        maskAllOutcomes();
      }
    }
  }, hasMaskedOutcomes ? unmaskText : maskText);
};
setGlobal('svs.components.poolBetting.bestBetRows.buttons.MaskToggleButton', MaskToggleButton);

 })(window);